import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ISettingsBookkeepingListResponse } from '@modules/general-settings/submodules/bookkeeping/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS,
  SETTINGS_BOOKKEEPING_LIST_QUERY_KEY,
  SETTINGS_BOOKKEEPING_LIST_URL,
} from '@modules/general-settings/submodules/bookkeeping/constants';

export default function useSettingsBookkeepingListQuery(): IContextQueryResult<ISettingsBookkeepingListResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ISettingsBookkeepingListResponse, Error>({
    queryKey: [SETTINGS_BOOKKEEPING_LIST_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet(SETTINGS_BOOKKEEPING_LIST_URL, {
      signal,
      permission: ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS.HISTORYOFLIMITCHANGES_CREATE,
    }),
  });
}
